/**
 * @license
 *
 * Copyright IBM Corp. 2019, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import CDSBreadcrumbItem from '@carbon/web-components/es/components/breadcrumb/breadcrumb-item.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import styles from './leadspace.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Breadcrumb item.
 *
 * @element c4d-breadcrumb-item
 */
@customElement(`${c4dPrefix}-breadcrumb-item`)
class C4DBreadcrumbItem extends StableSelectorMixin(CDSBreadcrumbItem) {
  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static styles = styles;
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DBreadcrumbItem;
